export const DEFAULT_CLOCK = '--:--'
export const MODAL_LOCK_TIMEOUT = 200 // ms to prevent modal from closing on mount
